import { Grid, List } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useThemeProvider } from "../../providers/ThemeProvider";
import { ResponseValues } from "../../values/strings";
import {
  TransactionDetailsListViewItemComponent,
  TransactionDetailsReceiptListViewItemComponent,
} from "./item/TransactionListViewItemComponent";

export const TransactionDetailsListViewComponent = ({ data }) => {
  const theme = useThemeProvider();
  const { t, i18n } = useTranslation();
  return (
    <List>
      <TransactionDetailsListViewItemComponent
        title={t("sender")}
        data={data}
        name={ResponseValues.sender}
      />
      <TransactionDetailsListViewItemComponent
        title={t("receiver")}
        data={data}
        name={ResponseValues.receiver}
      />
      <TransactionDetailsListViewItemComponent
        title={t("amount")}
        data={data}
        name={ResponseValues.amount}
      />
      <TransactionDetailsListViewItemComponent
        title={t("currency")}
        data={data}
        name={ResponseValues.makeConverted(ResponseValues.token)}
      />
      <TransactionDetailsListViewItemComponent
        title={t("transactionType")}
        data={data}
        name={ResponseValues.makeConverted(ResponseValues.type)}
      />
      <TransactionDetailsListViewItemComponent
        title={t("transactionId")}
        data={data}
        name={ResponseValues.txid}
      />
      <TransactionDetailsListViewItemComponent
        title={t("state")}
        data={data}
        name={ResponseValues.makeConverted(ResponseValues.state)}
      />
    </List>
  );
};

export const TransactionDetailsReceiptListViewComponent = ({ data }) => {
  const theme = useThemeProvider();
  const { t, i18n } = useTranslation();
  return (
    <List>
      <TransactionDetailsReceiptListViewItemComponent
        title={t("sender")}
        data={data}
        name={ResponseValues.sender}
      />
      <TransactionDetailsReceiptListViewItemComponent
        title={t("receiver")}
        data={data}
        name={ResponseValues.receiver}
      />
      <TransactionDetailsReceiptListViewItemComponent
        title={t("amount")}
        data={data}
        name={ResponseValues.amount}
      />
      <TransactionDetailsReceiptListViewItemComponent
        title={t("currency")}
        data={data}
        name={ResponseValues.makeConverted(ResponseValues.token)}
      />
      <TransactionDetailsReceiptListViewItemComponent
        title={t("transactionType")}
        data={data}
        name={ResponseValues.makeConverted(ResponseValues.type)}
      />
      <TransactionDetailsReceiptListViewItemComponent
        title={t("transactionId")}
        data={data}
        name={ResponseValues.txid}
      />
      <TransactionDetailsReceiptListViewItemComponent
        title={t("state")}
        data={data}
        name={ResponseValues.makeConverted(ResponseValues.state)}
      />
      <TransactionDetailsReceiptListViewItemComponent
        title={t("creationDate")}
        data={data}
        name={ResponseValues.creationDate}
      />
    </List>
  );
};
